import { createAction, props } from "@ngrx/store";
import { WondeSyncMismatch } from "@core/models/domain/wonde-sync.domain";
import { AssignGroupsForWondeSyncMismatchRequest, LinkWondeSyncMismatchRequest } from "@core/models/request/wonde-sync.request";

// LOAD THE RECORDS AWAITING REVIEW
export const loadMismatches = createAction('[WondeSync] Load Mismatches');
export const loadMismatchesSuccess = createAction(
  '[WondeSync] Load Mismatches Success',
  props<{ mismatches: WondeSyncMismatch[] }>()
);
export const loadMismatchesFailure = createAction(
  '[WondeSync] Load Mismatches Failure',
  props<{ error: any }>()
);

// LOAD THE RECORDS THE SCHOOL SKIPPED
export const loadSkippedMismatches = createAction('[WondeSync] Load Skipped Mismatches');
export const loadSkippedMismatchesSuccess = createAction(
  '[WondeSync] Load Skipped Mismatches Success',
  props<{ mismatches: WondeSyncMismatch[] }>()
);
export const loadSkippedMismatchesFailure = createAction(
  '[WondeSync] Load Skipped Mismatches Failure',
  props<{ error: any }>()
);

// LINK THE SELECTED PUPIL, keeping or taking the MIS data
export const linkMismatch = createAction(
  '[WondeSync] Link Mismatch',
  props<{ request: LinkWondeSyncMismatchRequest }>()
);
export const linkMismatchSuccess = createAction(
  '[WondeSync] Link Mismatch Success',
  props<{ mismatchId: string }>()
);
export const linkMismatchFailure = createAction(
  '[WondeSync] Link Mismatch Failure',
  props<{ mismatchId: string; error: any }>()
);

// CREATE A NEW PUPIL (no existing pupil is the right one)
export const createPupil = createAction(
  '[WondeSync] Create Pupil',
  props<{ mismatchId: string }>()
);
export const createPupilSuccess = createAction(
  '[WondeSync] Create Pupil Success',
  props<{ mismatchId: string }>()
);
export const createPupilFailure = createAction(
  '[WondeSync] Create Pupil Failure',
  props<{ mismatchId: string; error: any }>()
);

// SKIP (reject the MIS record)
export const dismissMismatch = createAction(
  '[WondeSync] Dismiss Mismatch',
  props<{ mismatchId: string; note?: string | null }>()
);
export const dismissMismatchSuccess = createAction(
  '[WondeSync] Dismiss Mismatch Success',
  props<{ mismatchId: string }>()
);
export const dismissMismatchFailure = createAction(
  '[WondeSync] Dismiss Mismatch Failure',
  props<{ mismatchId: string; error: any }>()
);

// ASSIGN GROUPS (a pupil whose year the sync could not work out)
export const assignGroups = createAction(
  '[WondeSync] Assign Groups',
  props<{ request: AssignGroupsForWondeSyncMismatchRequest }>()
);
export const assignGroupsSuccess = createAction(
  '[WondeSync] Assign Groups Success',
  props<{ mismatchId: string }>()
);
export const assignGroupsFailure = createAction(
  '[WondeSync] Assign Groups Failure',
  props<{ mismatchId: string; error: any }>()
);
